import { useState } from 'react';
import Button from '../../../shared/components/Button';

// Show-once API key modal (same pattern as the merchants detail page): the raw
// key exists only in this modal's props — once dismissed it cannot be recovered,
// only rotated.
export function ApiKeyModal({ apiKey, onClose }: { apiKey: string; onClose: () => void }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(apiKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg w-full max-w-lg">
        <div className="p-6 border-b">
          <h2 className="text-xl font-bold text-foreground">API Key Generated</h2>
        </div>
        <div className="p-6 space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-md p-3 text-sm text-amber-800">
            Copy this key now — it will never be shown again.
          </div>
          <div className="flex gap-2">
            <code className="flex-1 bg-muted rounded-md px-3 py-2 text-sm font-mono break-all">{apiKey}</code>
            <button
              onClick={copy}
              className="px-3 py-2 border border-border rounded-md text-sm hover:bg-muted whitespace-nowrap"
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
          <Button onClick={onClose} className="w-full">Done</Button>
        </div>
      </div>
    </div>
  );
}
